var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgComponentError = function SvgComponentError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 92,
    height: 82,
    viewBox: "0 0 92 82"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#6c6c6c",
    "data-name": "1692590_attention_error_exclamation_exclamation mark_hardware_icon",
    transform: "translate(-11.6 -13.6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.14 50.681A22.459 22.459 0 1 0 103.6 73.14a22.525 22.525 0 0 0-22.46-22.459m0 39.978A17.518 17.518 0 1 1 98.659 73.14 17.54 17.54 0 0 1 81.14 90.659",
    "data-name": "Path 13372"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.81 62.768h4.492v13.476H78.81z",
    "data-name": "Rectangle 18082"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.81 79.205h4.492v4.492H78.81z",
    "data-name": "Rectangle 18083"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.593,
    cy: 3.593,
    r: 3.593,
    "data-name": "Ellipse 1568",
    transform: "translate(23.054 48.557)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.593,
    cy: 3.593,
    r: 3.593,
    "data-name": "Ellipse 1569",
    transform: "translate(33.706 48.557)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.593,
    cy: 3.593,
    r: 3.593,
    "data-name": "Ellipse 1570",
    transform: "translate(23.054 25.928)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.593,
    cy: 3.593,
    r: 3.593,
    "data-name": "Ellipse 1571",
    transform: "translate(33.706 25.928)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.593,
    cy: 3.593,
    r: 3.593,
    "data-name": "Ellipse 1572",
    transform: "translate(23.054 71.268)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.593,
    cy: 3.593,
    r: 3.593,
    "data-name": "Ellipse 1573",
    transform: "translate(33.706 71.268)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.704 26.516h17.967v6.064H68.704z",
    "data-name": "Rectangle 18084"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.366 82.631V66.6h37.662a22.4 22.4 0 0 1 2.932-6.68H18.366V43.885h75.1v6.68a25.5 25.5 0 0 1 6.766 5.344V16.94a3.447 3.447 0 0 0-3.383-3.34H14.983a3.447 3.447 0 0 0-3.383 3.34v69.031a3.447 3.447 0 0 0 3.383 3.34H60.99a33 33 0 0 1-4.059-6.68Zm0-62.351h75.1V37.2h-75.1Z",
    "data-name": "Path 13373"
  }))));
};
export { SvgComponentError as Icon };
export default __webpack_public_path__ + "static/media/14ed87a4015d4edbd17f0f5363680668.svg";